import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, SpermSourceDetailsController, SpermSourceDetailsRequest, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'fclinicalexaminationnoheader',
  templateUrl: './fclinicalexaminationnoheader.component.html',
  styleUrls: ['./fclinicalexaminationnoheader.component.scss']
})

export class FclinicalexaminationNoHeaderPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  
  public TemplateName: string;
 
  public Date: Date;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;
  //@Input() reportCode: number;

  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadMedicalHistory() {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;
    r1.PatientReportCode = this.route.snapshot.paramMap.get('ReportCode');
    //r1.PatientReportCode = this.reportCode.toString();
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          this.SetForm();
          this.LoadSperm();
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  public viewmode: string = 'view';
  public fo: FormOrganizer;

  SetForm() {
    //alert("Form");
    this.fo = new FormOrganizer();

    this.fo.Sections = new Array<SectionData>();
    var i = 0;
    while (i < this.FormData.length) {
      this.fo.Sections.push(this.FormData[i]);
      i++;
    }
    this.fo.Organize();
  }
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.route.snapshot.paramMap.get('FormattedCode');
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentSpermSourceDetailsController: SpermSourceDetailsController[];
  //SpermEndInfo: SpermSourceDetailsController;
  CurrentSpermSourceDetailsRequest: SpermSourceDetailsRequest;
  TreatmentCycleCode: any;
  LoadSperm() {
    this.CurrentSpermSourceDetailsRequest = new SpermSourceDetailsRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentSpermSourceDetailsRequest.Branch = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentSpermSourceDetailsRequest.ConditionalOperator = 10;
    this.CurrentSpermSourceDetailsRequest.FromDate = new Date();
    this.CurrentSpermSourceDetailsRequest.ToDate = new Date();
    //this.CurrentSpermSourceDetailsRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSpermSourceDetailsRequest.SemanDataCode = 0;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    //this.SemanDataCode = this.route.snapshot.paramMap.get('SemanDataCode');
    this.CurrentSpermSourceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetSpermSourceDetailsController();
  }

  GetSpermSourceDetailsController() {
    this.StartRefreshing();
    this.CurrentSpermSourceDetailsRequest.CycleCode = this.TreatmentCycleCode;
    //this.CurrentSpermSourceDetailsRequest.SemanDataCode = this.SemanDataCode;

    this.actorservice.GetSpermSourceDetailsController(this.CurrentSpermSourceDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSpermSourceDetailsController = this.ApiResData.Result;
          //this.SpermEndInfo = this.CurrentSpermSourceDetailsController[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.TemplateName = this.route.snapshot.paramMap.get('TemplateName');
  

    this.LoadPatients();
    this.LoadMedicalHistory();


  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








